import { SeriesOptionsType } from "highcharts";
import { SerieEstadistica } from "../entities/serie-estadistica";
import { GraficaSerie } from "./grafica-serie";
import * as Highcharts from "highcharts";
import { formatNumber } from "@angular/common";

export class UtilidadDashboard {

    public paletaColores: Array<string> = ['#003E6C', '#359A33', '#ff7f0f', '#4D4F5B', '#003145', '#a91f11', '#71c299', '#4682b4', '#e79601', '#4C92B2', '#b53d03', '#8c1fb3', '#077307']

    public generaMapaFechas(lista: Array<SerieEstadistica>): Map<number, number> {
        //Armar un mapa con todas las fechas de todas las series sin importar su periodicidad.
        let mapaFechas = new Map<number, number>();
        //Recorre todas las series y se genera el mapa
        for (let i = 0; i < lista.length; i++) {
            for (let j = 0; j < lista[i].data.length; j++) {
                mapaFechas.set(lista[i].data[j][0], 1);
            }
        }
        return mapaFechas;
    }

    public getFechaMinima(mapaFechas: Map<number, number>): number {
        var keys = Array.from(mapaFechas.keys());
        keys = keys.sort((a, b) => {
            return a - b;
        });
        return keys[0];
    }

    public getFechaMaxima(mapaFechas: Map<number, number>): number {
        var keys = Array.from(mapaFechas.keys());
        keys = keys.sort((a, b) => {
            return a - b;
        });
        return keys[keys.length - 1];
    }

    public getMapaDataSet(lista: Array<SerieEstadistica>, mapaFechas: Map<number, number>): Map<number, Map<any, any>> {
        var mapaDataSet: Map<number, Map<any, any>> = new Map<number, Map<any, any>>();
        lista.forEach(serie => {
            var nombre = this.ajustarNombre(serie.descripcion);
            var id = serie.id;
            var mapaData: Map<any, any> = new Map<any, any>();
            mapaData.set('name', nombre);
            var fechas = Array.from(mapaFechas.keys());
            const mapaDataSerie = new Map();
            serie.data.map((obj) => {
                mapaDataSerie.set(obj[0], obj[1]);
            });
            fechas.forEach(fecha => {
                if (mapaDataSerie.has(fecha)) {
                    mapaData.set(fecha, mapaDataSerie.get(fecha));
                } else {
                    mapaData.set(fecha, '-');
                }
            });
            mapaDataSet.set(id, mapaData);
        });
        return mapaDataSet;
    }

    public getData(fecha: any, mapaDataSet: Map<number, Map<any, any>>): Array<Array<any>> {
        let dataChart: Array<Array<any>> = new Array();
        let indice = 0;
        mapaDataSet.forEach((value: Map<any, any>, key: number) => {
            var monto = value.get(fecha);
            var descripcion = value.get('name');
            let dato: [string, number] = [
                descripcion,
                monto
            ]
            dataChart.push(dato);
            indice++;
        });
        return dataChart;
    }

    public ajustarNombre(descripcion: string): string {
        var response: string = '';
        var listaDesc: string[] = descripcion.split(':');
        response = listaDesc[1];
        return response;
    }

    private months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

    //formatear las fechas al estandar el Banco
    public formatoFecha(milisegundos: number, periodicidad: string): string {
        var formattedDate: string;
        const KEY = periodicidad.toLocaleUpperCase();
        var fecha = new Date(milisegundos);
        try {
            switch (KEY) {
                case 'DIARIA':
                    formattedDate = fecha.getDate() + "-" + this.months[fecha.getMonth()] + "-" + fecha.getFullYear();
                    break;
                case 'SEMANAL':
                    formattedDate = fecha.getDate() + "-" + this.months[fecha.getMonth()] + "-" + fecha.getFullYear();
                    break;
                case 'MENSUAL':
                    formattedDate = this.months[fecha.getMonth()] + "/" + fecha.getFullYear();
                    break;
                case 'ANUAL':
                    formattedDate = fecha.getFullYear() + "";
                    break;
                default:
                    formattedDate = '';
                    break;
            }
            return formattedDate;
        } catch (error) {
            console.error("show:formatDate: " + error);
            return " ";
        }
    }

    public initChartMoneda(): Highcharts.Options {
        return {
            title: {
                text: 'monedas'
            },
            series: [{
                type: 'line',
                data: []
            }],
            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            }
        }
    }

    public initChartCiudades(): Highcharts.Options {
        let listaInit: Array<any> = new Array();
        const element = {
            name: 'Serie',
            data: [1],
            pointPlacement: 'on'
        };
        listaInit.push(element);

        return {

            chart: {
                polar: true,
                type: 'line'
            },

            title: {
                text: 'Spiderweb'
            },

            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            legend: {
                enabled: false
            },

            pane: {
                size: '80%'
            },

            plotOptions: {
                line: {
                    marker: {
                        enabled: false
                    }
                }
            },

            xAxis: {
                categories: ['Cat1'],
                tickmarkPlacement: 'on',
                lineWidth: 0
            },

            yAxis: {
                gridLineInterpolation: 'polygon',
                lineWidth: 0,
                min: 0
            },
            tooltip: {
                shared: true,
                pointFormat: ''
            },
            series: listaInit,
        }
    }

    public initChartOptions(): Highcharts.Options {
        return {
            chart: {
                type: 'bar',
                animation: {
                    duration: 1000,
                },
            },
            title: {
                text: 'chart'
            },
            plotOptions: {
                series: {
                    animation: true,
                    /*dataSorting: {
                        enabled: true,
                        matchByName: true
                    }*/
                },
                bar: {
                    borderRadius: '50%',
                    dataLabels: {
                        enabled: true
                    },
                    groupPadding: 0,
                    
                }
            },
            series: [{
                type: 'bar',
                data: []
            }],
            colors: this.paletaColores,
            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            }
        }
    }

    public initChartGenerico(numSeriesGraph: number, type: string): Highcharts.Options {
        let listaInit: Array<any> = new Array();
        for (let index = 0; index < numSeriesGraph; index++) {
            const element = {
                type: type,
                data: []
            };
            listaInit.push(element);
        }
        return {
            title: {
                text: 'chart'
            },
            series: listaInit,
            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            plotOptions: {
                series: {
                    animation: false
                }
            }
        }
    }

    public getAditionalHighchartsOptions(listaSeriesChart: any[], titulo: string, seriesAxisPosition: { [key: number]: boolean }): Highcharts.Options {
        let gs: GraficaSerie = new GraficaSerie();
        let tituloEjeX = gs.generaTituloEjeX(listaSeriesChart);
        let yAxis = gs.generaTituloEjeY(listaSeriesChart, seriesAxisPosition);
        return {
            chart: {
                height: 700,
                zooming: {
                    mouseWheel: {
                        enabled: false
                    },
                    type: 'xy'
                },
                marginBottom: 200,
                resetZoomButton: {
                    position: {
                        x: -0,
                        y: -0
                    }
                }
            },
            title: {
                text: titulo,
                align: 'center',
                x: -99,
                style: {
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: '#004677'
                }
            },
            credits: {
                enabled: false,
                text: ''
            },
            series: listaSeriesChart,
            yAxis: yAxis,
            xAxis: {
                type: 'datetime',
                ordinal: false,
                title: {
                    text: tituloEjeX,
                    margin: 20,
                    style: {
                        fontSize: '12',
                        fontWeight: '500',
                        color: 'rgb(128, 128, 128)',
                    }
                },
                labels: {
                    rotation: -90,
                    style: {
                        fontSize: '12',
                        fontWeight: 'normal',
                        color: 'rgb(51, 51, 51)'
                    }
                },
            }
        }
    }

    public getSerieChart(serie: SerieEstadistica, numY: number, colorLinea: string): any {
        let gs: GraficaSerie = new GraficaSerie();
        //let colorLinea = gs.getColor();
        let serieChart: any = {
            marker: {
                enabled: false,
                states: {
                    hover: {
                        enabled: true
                    }
                }
            },
            yAxis: numY,
            name: serie.nombre,
            data: serie.data,
            id: serie.id + '',
            color: colorLinea,
            unidadCorta: serie.unidadCorta,
            numeroDecimales: serie.numeroDecimales,
            idPeriodicidad: serie.idPeriodicidad,
            periodicidadNombre: serie.descripcionPeriodicidad,
            fuente: serie.fuente,
            notas: serie.notas,
            type: serie.tipoVisualizacion
        };
        return serieChart;
    }

    public assignSeriesToYAxis(listaSeries: any[]) {
        let seriesLimits: { [key: number]: { [key: string]: number } } = {};
        let seriesAxisPosition: { [key: number]: boolean } = {};
        let seriesUnits: string[] = [];
        let maxValue = 0;
        let minValue = 0;
        if (listaSeries.length > 1) {
            for (let serie of listaSeries) {
                if (serie.data) {
                    if (!seriesUnits.includes(serie.unidadCorta))
                        seriesUnits.push(serie.unidadCorta);
                    seriesLimits[serie.id] = {};
                    seriesLimits[serie.id]['max'] = serie.data.reduce((a: any, b: any) => a[1] > b[1] ? a : b)[1];
                    seriesLimits[serie.id]['min'] = serie.data.reduce((a: any, b: any) => a[1] < b[1] ? a : b)[1];
                    if (seriesLimits[serie.id]['max'] > maxValue)
                        maxValue = seriesLimits[serie.id]['max'];
                    if (seriesLimits[serie.id]['min'] < minValue && seriesLimits[serie.id]['min'] !== 0)
                        minValue = seriesLimits[serie.id]['min'];
                }
            }
            if (seriesUnits.length !== 2) {
                for (let serie of listaSeries) {
                    seriesAxisPosition[serie.id] = false;
                    if (serie.data && seriesUnits.length > 1) {
                        let valor = 1200;
                        if (serie.subcategoria === 'Monedas de reserva')
                            valor = 5700;
                        if (serie.nombre.includes('/USD - Tasa'))
                            valor = 25000;
                        if (maxValue - seriesLimits[serie.id]['max'] > valor) {
                            seriesAxisPosition[serie.id] = true;
                        }
                    }
                }
            } else {
                for (let serie of listaSeries) {
                    seriesAxisPosition[serie.id] = false;
                    if (serie.unidadCorta === seriesUnits[0])
                        seriesAxisPosition[serie.id] = true;
                }
            }
        } else {
            seriesAxisPosition[listaSeries[0].id] = false;
        }
        return seriesAxisPosition;
    }

    public getChartTile(listaSeries: Array<SeriesOptionsType>, titulo: string, subTitulo: string, unidad: string, periodicidad:string): Highcharts.Options {
        var util: UtilidadDashboard = new UtilidadDashboard();
        return {
            chart:{
                zooming: {
                    mouseWheel: false
                }
            },
            title: {
                text: titulo,
                align: "center",
                style: {
                    fontSize: '0.9rem',
                }
            },
            subtitle: {
                useHTML: false,
                text: subTitulo,                
                style: {
                    textAlign: 'center',
                    fontSize: '0.7rem'
                }
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            xAxis: {
                labels: {
                    enabled: false
                },
                title: {
                    text: null
                },
                startOnTick: false,
                endOnTick: false,
                tickPositions: []
            },
            yAxis: {
                endOnTick: false,
                startOnTick: false,
                labels: {
                    enabled: false
                },
                title: {
                    text: null
                },
                tickPositions: [0]
            },
            tooltip: {
                formatter: function () {
                    var seriesName = this.series.name;
                    var xValue = util.formatoFecha(Number(this.x), periodicidad);
                    var yValue = formatNumber(Number(this.y), 'co-ES', '1.' + 2 + '-' + 2);//this.y;

                    return '<b>' + seriesName + '</b><br>' +
                        'Fecha: ' + xValue + '<br>' +
                        'Valor: ' + yValue + ' ' + unidad;
                },
                style: {
                    fontSize: '0.7rem',
                    width: 150
                }
            },
            plotOptions: {
                line: {
                    animation: false
                },
                series: {
                    animation: false,
                    states: {
                        hover: {
                            enabled: false
                        }
                    }
                }
            },
            series: listaSeries,
            boost: {
                seriesThreshold: 4
            }
        }
    }

    public getChartSpider(listaSeries: Array<any>): Highcharts.Options {
        var series: Array<any> = new Array();
        var categorias: Array<string> = new Array();
        var data: Array<number> = new Array();
        var unidad = 'Variación anual: ';
        var palabraEliminar: string = 'Índice de precios al consumidor: ';
        var fecha: string = '';
        listaSeries.forEach(s => {
            var p = s.descripcion.replace(new RegExp(palabraEliminar, 'g'), '');
            categorias.push(p);
            data.push(s.valor);
            fecha = s.fecha;
        });
        series.push({
            name: 'Inflación por ciudad',
            data: data,
            pointPlacement: 'on'
        });

        return {
            chart: {
                polar: true,
                type: 'line'
            },
            title: {
                text: ''
            },
            pane: {
                size: '70%'
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            plotOptions: {
                line: {
                    marker: {
                        enabled: false
                    },
                    lineWidth: 2
                }
            },
            xAxis: {
                categories: categorias,
                tickmarkPlacement: 'between',
                lineWidth: 1,
                labels: {
                    style: {
                        fontSize: '10px'
                    }
                }
            },
            yAxis: {
                gridLineInterpolation: 'polygon',
                tickInterval: 2,
                lineWidth: 0,
                min: 0,
                labels: {
                    enabled: false
                }
            },
            tooltip: {
                shared: true,
                pointFormat: '<span><b>' + unidad + ' {point.y}</b></span><br><span>Fecha: ' + fecha + '</span>'
            },
            legend: {
                enabled: true
            },
            series: series,
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            align: 'center',
                            verticalAlign: 'bottom',
                            layout: 'horizontal'
                        },
                        pane: {
                            size: '70%'
                        }
                    }
                }]
            }

        }
    }

    public initChartTISF(): Highcharts.Options {
        let listaInit: Array<any> = new Array();
        for (let index = 0; index < 5; index++) {
            const element = {
                type: 'line',
                data: []
            };
            listaInit.push(element);
        }
        return {
            title: {
                text: 'chart'
            },
            series: listaInit,
            yAxis: [
                {
                    title: {
                        text: 'Millones de COP'
                    },
                    opposite: false
                },
                {
                    title: {
                        text: '%'
                    },
                    opposite: true
                }
            ],
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
        }
    }

    public getChartOptionsPI(fechaSlide: string, barRaceDatoMin: number, dataSerie: Array<Array<any>>): Highcharts.Options {
        var util: UtilidadDashboard = new UtilidadDashboard();
        return {
            title: {
                text: 'Inflación por grupo de gasto',
                align: "left",
                x: 30
            },
            subtitle: {
                useHTML: true,
                text: fechaSlide + ' <br> <p style="font-size: small;">Variación anual</p>',
                floating: true,
                /**************************************************************************************************** */
      /**************************EDITAR POR QUE SE GENERAR ERRRO EN LA ACTUALIZACIÓN*********************** */
      /**************************************************************************************************** */
                //align: 'left',
                y: 60,
                x: 0,
                style: {
                    fontSize: '1.3rem',
                    textAlign: 'center',
                    color: '#800000',
                    fontWeight: 'bold'
                }
            },
            xAxis: {
                type: 'category',
                gridLineWidth: 1,
                lineWidth: 1,
                height: 450,
                labels: {
                    useHTML: true,
                    formatter: function () {
                        return '<div class="div-contenido-ejex"> <p class="p-contenido-ejex">' + this.value + '</p><img class="img-contenido-ejex" src="/estadisticas-economicas/assets/img/BAR_RACE_ICON/' + this.value.toString().trim() + '.PNG"/></div>';
                    },
                    style: {
                        fontSize: '12px',
                        color: '#000',
                        width: 250,
                    }
                }
            },
            yAxis: {
                opposite: true,
                tickInterval: 1,
                title: {
                    text: '',
                    align: 'middle'
                },
                labels: {
                    overflow: 'justify'
                },
                gridLineWidth: 1
            },
            tooltip: {
                shared: true,
                pointFormat: '<span><b>Variación anual: {point.y}</b></span><br/>'
            },
            plotOptions: {
                series: {
                    //animation: true,
                    /*dataSorting: {
                        enabled: true,
                        matchByName: true
                    }*/
                },
                bar: {

                    borderRadius: '10%',
                    dataLabels: {
                        enabled: true
                    },
                    groupPadding: 0,
                    
                }
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            series: [
                {
                    type: 'bar',
                    name: util.formatoFecha(barRaceDatoMin, 'Mensual'),
                    data: dataSerie,
                    colorByPoint: true
                }
            ],

        };
    }


    public getHighchartsOptionsIntradia(data: any[]): Highcharts.Options {
        var listaCategorias: Array<any> = new Array();
        var listaNumeros: Array<any> = new Array();
        data.forEach(element => {
            var fecha: Date = new Date(element[0]);
            listaCategorias.push(fecha);
            listaNumeros.push(element[1]);
        });
        var vMin = Math.min(...listaNumeros);
        var vMax = Math.max(...listaNumeros);
        var listaData: Array<any[]> = new Array();
        var fechaInicial: Date = new Date(data[0][0]);
        listaData.push([fechaInicial, data[0][1]]);
        var ds: any = {
            name: 'Series 1',
            data: listaData,
            color: 'rgba(0,62,108,0.5)', // Color del área
        };
        return {
            chart: {
                type: 'area',
                marginTop: 100
            },
            title: {
                text: 'Comportamiento del mercado del dólar durante el día'
            },
            series: ds,
            xAxis: {
                type: 'datetime',
                minorTickInterval: 1,
                startOnTick: true,
                endOnTick: true,
                gridLineWidth: 1,
                tickInterval: 5 * 60 * 1000,
                title: {
                    text: 'Hora de la Transacción',
                    margin: 10,
                    style: {
                        fontSize: '11px',
                        fontWeight: 'bold',
                        color: 'rgb(128, 128, 128)',
                        fontFamily: 'arial, sans-serif'
                    }
                },
                labels: {
                    formatter: function () {
                        var fecha = new Date(Number(this.value));
                        return fecha.toLocaleTimeString();
                    },
                    rotation: -90,
                    style: {
                        fontSize: '11px',
                        fontWeight: 'normal',
                        color: 'rgb(51, 51, 51)',
                        fontFamily: 'Arial,sans-serif'
                    }

                }
            },
            yAxis: {
                minorTickInterval: 2.5,
                gridLineWidth: 1,
                min: vMin,
                max: vMax,
                title: {
                    text: 'Precio promedio ponderado (COP/USD)',
                    margin: 20,
                    style: {
                        fontSize: '11px',
                        fontWeight: 'bold',
                        color: 'rgb(128, 128, 128)',
                        fontFamily: 'tahoma, sans-serif'
                    }
                },
                labels: {
                    formatter: function (): string {
                        return '$' + this.value;
                    },
                    style: {
                        fontSize: '11px',
                        fontWeight: 'normal',
                        color: 'rgb(51, 51, 51)',
                        fontFamily: 'Arial,sans-serif'
                    }
                }
            },
            tooltip: {
                xDateFormat: '%Y-%m-%d %H:%M:%S',
                followPointer: true,
                followTouchMove: true,
                shared: true
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
        }
    }

    public getSerieOptions(infoSerie: any, tipo: any, color:string): SeriesOptionsType {
        var response: SeriesOptionsType = {
            name: '',
            type: tipo
        };
        if (tipo === 'line') {
            response = {
                name: infoSerie.descripcion,
                type: tipo,
                color: color,
                data: infoSerie.data,
            }
        } else {
            response = {
                name: infoSerie.descripcion,
                type: tipo,
                data: infoSerie.data,
                color: color,
                marker: false,
                fillColor: {
                    linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                    stops: [
                        [0, '#666'],
                        [1, '#eee']
                    ]
                },
                boostThreshold: 1000
            }
        }
        return response;
    }
}
